import React, { useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { MdCancel, MdInfoOutline } from "react-icons/md";
import { FaCamera } from "react-icons/fa6";
import axios from "axios";
import { toast } from "sonner";
import { updateUser } from "../../redux/users/userSlice";
import { useFetchData } from "../../hooks/useFtechData";
import {
  APPLICATION_API,
  CERTIFICATE_URL,
  EDUCATION_URL,
  GUARANTOR_URL,
  JOBSEEKER_URL,
  WORK_URL,
} from "../../resources/resource";
import { convertToBase64 } from "../../Utils/fileConverter";
import Header from "../../component/Header";
import FooterComponent from "../../component/Footer";
import LoadSpinner from "../../component/Modals/LoadSpinner";
import DefaultProfile from "../../assets/Images/employee.png";
// import GoogleImage from "../../assets/Images/locate.png";
import WorkExperienceList from "./Work";
import EducationList from "./Education";
import ContactList from "./ContactPerson";
import ApplicationTable from "./Application";
import EmploymentRecord from "./Employment";
import Certificate from "./Certificate";
import { useMakeRequest } from "../../hooks/useMakeRequest";
import { uploadToCloudinary } from "../../Utils/cloudinaryUpload";
import { Spinner } from "flowbite-react";
import { race } from "./data";
import JobSeekerNotification from "./JobSeekerNotifications";
import Search from "../../component/Search";
import SearchDashboard from "../Employer/SearchDashboard";
import EmployerEmployeeJobSeeker from "./EmployerEmployeeJobSeeker";
import EmployeeAttendance from "./EmployeeAttendance";
import BenefitHistory from "./BenefitHistory";
import JobSeekerBenefits from "./JobSeekerBenefit";
import BenefitSummary from "./BenefitSumarry";
import FaceAuth from "./FaceAuth";
import JobSeekerAvailabilityUpdate from "./JobseekerAvailabilityUpdates";
import UrgentJobSeekerAccept from "./UrgentJobSeekerAccept";
const ProfilePages = () => {
  const dispatch = useDispatch();
  const { currentUser, token } = useSelector((state) => state.user);
  const loggedInUser = useSelector((state) => state.user);
  const fileInputRef = useRef();
  const makeRequest = useMakeRequest();
  const votersCardInputRef = useRef();
  const residentialCardInputRef = useRef();
  const scanningEvidenceInputRef = useRef();
  const tenancyAgreementInputRef = useRef();

  const { data: userDetails, refetch: refetchUser } = useFetchData(
    JOBSEEKER_URL + `/getAjobSeeker/${loggedInUser?.currentUser?._id}`
  );

  const [changeListener, setChangeListener] = useState(false);
  const [loadingUpdate, setLoadingUpdate] = useState(false);
  const [loadingImageUpload, setLoadingImageUpload] = useState(false);
  const [loadingNINVerification, setLoadingNINVerification] = useState(false);
  const [ninVerificationStatus, setNINVerificationStatus] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);
  const [votersCardPreview, setVotersCardPreview] = useState(null);
  const [residentialCardPreview, setResidentialCardPreview] = useState(null);
  const [scanningEvidencePreview, setScanningEvidencePreview] = useState(null);
  const [tenancyAgreementPreview, setTenancyAgreementPreview] = useState(null);
  const [imageChange, setImageChange] = useState(false);
  const [votersCard, setVotersCard] = useState(null);
  const [residentialCard, setResidentialCard] = useState(null);
  const [scanningEvidence, setScanningEvidence] = useState(null);
  const [tenancyAgreement, setTenancyAgreement] = useState(null);
  const [imageFile, setImageFile] = useState(null);
  const [faceData, setFaceData] = useState(null);
  const [profileInfo, setProfileInfo] = useState({
    jobSeekerId: loggedInUser?.currentUser?._id,
    nin: '',
  });

  const userId = localStorage.getItem('userId')
  console.log(userId)

  const handleProfileChange = (e) => {
    setProfileInfo({
      ...profileInfo,
      [e.target.name]: e.target.value,
      jobSeekerId: loggedInUser.currentUser._id,
    });
    setChangeListener(true);
  };

   const handleAvatar = async (e, fileType) => {
    const file = e.target.files[0];
    if (!file) return;

    switch (fileType) {
      case "avatar":
        setImageFile(file);
        setPreviewImage(URL.createObjectURL(file));
        break;
      case "votersCard":
        setVotersCard(file);
        setVotersCardPreview(URL.createObjectURL(file));
        break;
      case "residentialCard":
        setResidentialCard(file);
        setResidentialCardPreview(URL.createObjectURL(file));
        break;
      case "scanningEvidence":
        setScanningEvidence(file);
        setScanningEvidencePreview(URL.createObjectURL(file));
        break;
      case "tenancyAgreement":
        setTenancyAgreement(file);
        setTenancyAgreementPreview(URL.createObjectURL(file));
        break;
      default:
        break;
    }
    setImageChange(true);
  };

  const handleUpdateImage = async () => {
    // if (!imageFile && !votersCard && !residentialCard && !scanningEvidence && !tenancyAgreement) {
    //   return toast.error("Kindly select at least one file to upload");
    // }
     
    if (!imageFile && !votersCard && !residentialCard && !scanningEvidence && !tenancyAgreement && !faceData) {
      return toast.error('Kindly select at least one file or complete face authentication to upload');
    }
    setLoadingImageUpload(true);
    try {
      const payload = {};
      if (imageFile) {
        const imageURL = await uploadToCloudinary(imageFile);
        if (imageURL) payload.avatar = imageURL;
      }
      if (votersCard) {
        const votersCardURL = await uploadToCloudinary(votersCard);
        if (votersCardURL) payload.votersCard = votersCardURL;
      }
      if (residentialCard) {
        const residentialCardURL = await uploadToCloudinary(residentialCard);
        if (residentialCardURL) payload.residentialCard = residentialCardURL;
      }
      if (scanningEvidence) {
        const scanningEvidenceURL = await uploadToCloudinary(scanningEvidence);
        if (scanningEvidenceURL) payload.scanningEvidence = scanningEvidenceURL;
      }
      if (tenancyAgreement) {
        const tenancyAgreementURL = await uploadToCloudinary(tenancyAgreement);
        if (tenancyAgreementURL) payload.tenancyAgreement = tenancyAgreementURL;
      }

       if (faceData) {
        payload.faceData = JSON.stringify(faceData);
      }


      if (Object.keys(payload).length === 0) {
        return toast.error("Error uploading files");
      }

      makeRequest(
        JOBSEEKER_URL + `/updateJobSeeker/${loggedInUser?.currentUser?._id}`,
        "PUT",
        payload,
        (data) => {
          refetchUser();
          toast.success("Files uploaded successfully");
        },
        (error) => {
          console.log(error || "Error updating files");
          toast.error("Error updating files");
        },
        () => {
          setImageChange(false);
          setLoadingImageUpload(false);
        }
      );
    } catch (error) {
      toast.error("Unknown error, please try again later");
      setLoadingImageUpload(false);
    }
  };
   const handleUpdate = async () => {
    setLoadingUpdate(true);
    makeRequest(
      JOBSEEKER_URL + `/updateJobSeeker/${loggedInUser?.currentUser?._id}`,
      "PUT",
      profileInfo,
      (data) => {
        refetchUser();
      },
      (error) => {
        console.log(error);
      },
      () => {
        setLoadingUpdate(false);
        setChangeListener(false);
      }
    );
  };


    const handleVerifyNIN = async () => {
    if (!profileInfo.nin || !/^\d{11}$/.test(profileInfo.nin)) {
      toast.error("Please enter a valid 11-digit NIN");
      return;
    }

    setLoadingNINVerification(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}jobseeker/verify-nin`,
        { nin: profileInfo.nin, userId },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      setNINVerificationStatus({
        status: 'success',
        data: response.data.verifiedData,
      });
      dispatch(updateUser({
        ...loggedInUser.currentUser,
        nin: response.data.verifiedData.nin,
        isNINVerified: true,
        firstName: response.data.verifiedData.firstName || loggedInUser.currentUser.firstName,
        lastName: response.data.verifiedData.lastName || loggedInUser.currentUser.lastName,
        dateOfBirth: response.data.verifiedData.dateOfBirth || loggedInUser.currentUser.dateOfBirth,
      }));
      toast.success("NIN verified successfully");
    } catch (error) {
      setNINVerificationStatus({
        status: 'error',
        message: error.response?.data?.msg || "Error verifying NIN",
      });
      toast.error(error.response?.data?.msg || "Error verifying NIN");
    } finally {
      setLoadingNINVerification(false);
    }
  };


  return (
    <div className="min-h-screen bg-gray-50 pt-16 sm:pt-20">
      <Header darkMode={true} />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Import Notice */}
        {/* <div className="mb-8 bg-blue-50 border border-blue-200 rounded-lg p-4">
          <div className="flex items-start gap-3">
            <MdInfoOutline className="text-orange-500 text-xl flex-shrink-0 mt-0.5" />
            <div className="flex-1">
              <p className="text-sm text-orange-700 mb-4">
                For a better experience and to avoid errors, we recommend
                importing your account details if you already have an account on
                our other platforms.
              </p>
              <div className="flex flex-wrap gap-3">
                <button className="px-4 py-2 bg-orange-600 text-white rounded-md hover:bg-blue-700 transition-colors">
                  Import from e-school
                </button>
                <button className="px-4 py-2 bg-orange-600 text-white rounded-md hover:bg-blue-700 transition-colors">
                  Import from E-Verify
                </button>
              </div>
            </div>
            <button className="text-gray-400 hover:text-gray-500">
              <MdCancel className="text-xl" />
            </button>
          </div>
        </div> */}

        {/* Profile Section */}
        <div className="bg-white rounded-lg shadow-sm p-6 mb-8">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            {/* Profile Picture Section */}
            <div className="space-y-6">
              <label>Your profile picture</label>
                   <div className="relative flex items-center">
                 
                <img
                  src={previewImage || userDetails?.avatar || DefaultProfile}
                  alt="Profile"
                  className="w-32 h-32 rounded-full object-cover border-4 border-gray-100 shadow-sm"
                />
                <button
                  onClick={() => fileInputRef.current.click()}
                  className="absolute bottom-0 left-0 p-2 bg-white rounded-full shadow-lg hover:bg-gray-50 transition-colors"
                >
                  <FaCamera className="text-gray-600" />
                </button>
                <input
                  ref={fileInputRef}
                  type="file"
                  name="avatar"
                  onChange={(e) => handleAvatar(e, "avatar")}
                  className="hidden"
                />
                {imageChange ? (
                  <button
                    onClick={handleUpdateImage}
                    className="bg-green-400 ml-2 hover:bg-green-500 text-white p-[3px] rounded-sm"
                  >
                    {loadingImageUpload ? <Spinner /> : "Upload"}
                  </button>
                ) : null}
              </div>
                 <label>Face Authentication</label>
              <FaceAuth onFaceData={setFaceData} token={token} />
              {/* Voters Card */}
                   <label className="mt-3">Your Voters card</label>
              <div className="relative flex items-center">
                <img
                  src={votersCardPreview || userDetails?.votersCard || DefaultProfile}
                  alt="Voter's Card"
                  className="w-32 h-32 rounded-full object-cover border-4 border-gray-100 shadow-sm"
                />
                <button
                  onClick={() => votersCardInputRef.current.click()}
                  className="absolute bottom-0 left-0 p-2 bg-white rounded-full shadow-lg hover:bg-gray-50 transition-colors"
                >
                  <FaCamera className="text-gray-600" />
                </button>
                <input
                  ref={votersCardInputRef}
                  type="file"
                  name="votersCard"
                  onChange={(e) => handleAvatar(e, "votersCard")}
                  className="hidden"
                />
              </div>

              {/* Residential Card */}
              <label className="mt-3">Your residential card</label>
              <div className="relative flex items-center">
                <img
                  src={residentialCardPreview || userDetails?.residentialCard || DefaultProfile}
                  alt="Residential Card"
                  className="w-32 h-32 rounded-full object-cover border-4 border-gray-100 shadow-sm"
                />
                <button
                  onClick={() => residentialCardInputRef.current.click()}
                  className="absolute bottom-0 left-0 p-2 bg-white rounded-full shadow-lg hover:bg-gray-50 transition-colors"
                >
                  <FaCamera className="text-gray-600" />
                </button>
                <input
                  ref={residentialCardInputRef}
                  type="file"
                  name="residentialCard"
                  onChange={(e) => handleAvatar(e, "residentialCard")}
                  className="hidden"
                />
              </div>
              {/* Scanning Evidence */}
                 <label className="mt-3">Your scanning evidence</label>
              <div className="relative flex items-center">
                <img
                  src={scanningEvidencePreview || userDetails?.scanningEvidence || DefaultProfile}
                  alt="Scanning Evidence"
                  className="w-32 h-32 rounded-full object-cover border-4 border-gray-100 shadow-sm"
                />
                <button
                  onClick={() => scanningEvidenceInputRef.current.click()}
                  className="absolute bottom-0 left-0 p-2 bg-white rounded-full shadow-lg hover:bg-gray-50 transition-colors"
                >
                  <FaCamera className="text-gray-600" />
                </button>
                <input
                  ref={scanningEvidenceInputRef}
                  type="file"
                  name="scanningEvidence"
                  onChange={(e) => handleAvatar(e, "scanningEvidence")}
                  className="hidden"
                />
              </div>
              {/* Tenancy Agreement */}
                 <label className="mt-3">Your tenancy agreement</label>
              <div className="relative flex items-center">
                <img
                  src={tenancyAgreementPreview || userDetails?.tenancyAgreement || DefaultProfile}
                  alt="Tenancy Agreement"
                  className="w-32 h-32 rounded-full object-cover border-4 border-gray-100 shadow-sm"
                />
                <button
                  onClick={() => tenancyAgreementInputRef.current.click()}
                  className="absolute bottom-0 left-0 p-2 bg-white rounded-full shadow-lg hover:bg-gray-50 transition-colors"
                >
                  <FaCamera className="text-gray-600" />
                </button>
                <input
                  ref={tenancyAgreementInputRef}
                  type="file"
                  name="tenancyAgreement"
                  onChange={(e) => handleAvatar(e, "tenancyAgreement")}
                  className="hidden"
                />
              </div>
              <div className="p-4 bg-gray-50 rounded-lg border border-gray-200">
                <h3 className="font-medium text-gray-900 mb-2">
                  Primary Address
                </h3>
                <p className="text-gray-600">
                  {loggedInUser.currentUser.address || "No address provided"}
                </p>
              </div>

                  {/* <div className="relative flex items-center">
                <img
                  src={previewImage || userDetails?.avatar1 || DefaultProfile}
                  alt="evidence of payment"
                  className="w-32 h-32 rounded-full object-cover border-4 border-gray-100 shadow-sm"
                />
                <button
                  onClick={() => fileInputRef.current.click()}
                  className="absolute bottom-0 left-0 p-2 bg-white rounded-full shadow-lg hover:bg-gray-50 transition-colors"
                >
                  <FaCamera className="text-gray-600" />
                </button>


                
                <input
                  ref={fileInputRef}
                  type="file"
                  name="avatar1"
                  onChange={handleAvatar}
                  className="hidden"
                />
                {imageChange ? (
                  <button
                    onClick={handleUpdateImage}
                    className="bg-green-400 ml-2 hover:bg-green-500 text-white p-[3px] rounded-sm"
                  >
                    {loadingImageUpload ? <Spinner /> : "Upload"}
                  </button>
                ) : null}
              </div> */}
            </div>

            {/* Personal Information */}
            <div className="space-y-4">
              <FormField
                label="First Name"
                name="firstName"
                type="text"
                value={profileInfo.firstName}
                placeholder={loggedInUser.currentUser.firstName}
                onChange={handleProfileChange}
              />
              <FormField
                label="Email"
                name="email"
                type="email"
                value={profileInfo.email}
                placeholder={loggedInUser.currentUser.email}
                onChange={handleProfileChange}
              />
              <FormField
                label="Date of Birth"
                name="dateOfBirth"
                type="date"
                placeholder={loggedInUser.currentUser.dateOfBirth}
                value={profileInfo.dateOfBirth}
                onChange={handleProfileChange}
              />
              <SelectField
                label="Gender"
                name="gender"
                placeholder={loggedInUser.currentUser.gender}
                value={profileInfo.gender}
                onChange={handleProfileChange}
                options={["male", "female"]}
              />
              <SelectField
                label="Job Decision"
                name="jobDecision"
                placeholder={loggedInUser.currentUser.jobDecision}
                value={profileInfo.jobDecision}
                onChange={handleProfileChange}
                options={["job-seeker", "job-changer"]}
              />
           
                 <SelectField
                label="Do you live alone"
                name="liveAlone"
                value={profileInfo.liveAlone}
                onChange={handleProfileChange}
                options={["Yes", "No"]}
              />

              {profileInfo.liveAlone === "No" && (
                   <FormField
                label="who do you live"
                name="whoDoYouLiveWith"
                type="text"
                value={profileInfo.whoDoYouLiveWith}
                onChange={handleProfileChange}

                
              />
              )}
               
           

                  
            
                   <FormField
                label="how much is your rent"
                name="rentfee"
                type="text"
                placeholder={loggedInUser.currentUser.rentfee}
                value={profileInfo.rentfee}
                onChange={handleProfileChange}
              />

                       <FormField
                label="landlord or Agent Number"
                name="landlordNumber"
                type="text"
                value={profileInfo.landlordNumber}
                placeholder={loggedInUser.currentUser.landlordNumber}
                onChange={handleProfileChange}
              />
                       <FormField
                label="number of Rooms"
                name="numberOfRooms"
                type="text"
                value={profileInfo.numberOfRooms}
                placeholder={loggedInUser.currentUser.numberOfRooms}
                onChange={handleProfileChange}
              />
                       <FormField
                label="number of people living in the house"
                name="numberOfPeople"
                type="text"
                value={profileInfo.numberOfPeople}
                    placeholder={loggedInUser.currentUser.numberOfPeople}
                onChange={handleProfileChange}
              />

                  <FormField
                label="tiktokHandle"
                name="tiktokHandle"
                type="text"
                value={profileInfo.tiktokHandle}
                placeholder={loggedInUser.currentUser.tiktokHandle}
                onChange={handleProfileChange}
              />
                 <FormField
                label="instagramHandle"
                name="instagramHandle"
                type="text"
                value={profileInfo.instagramHandle}
                placeholder={loggedInUser.currentUser.instagramHandle}
                onChange={handleProfileChange}
              />
                

                  <SelectField
                 label="registered with e-verify?"
                name="registeredEverify"
                value={profileInfo.registeredEverify}
                onChange={handleProfileChange}
                options={["No", "Yes", ]}
              />

            
                   <FormField
                label="next of kin Name"
                name="nextOfKin"
                type="text"
                value={profileInfo.nextOfKin}
                placeholder={loggedInUser.currentUser.nextOfKin}
                onChange={handleProfileChange}
              />
                   <SelectField
                label="marital status"
                name="maritalStatus"
                value={profileInfo.maritalStatus}
                onChange={handleProfileChange}
                options={["single", "married", "divorce", "widow", "widower", "separated"]}
              />


              {profileInfo.nextOfKin !=='' && (
                <>
                     <FormField
                label="next of kin phoneNumber"
                name="nextOfKinNumber"
                type="number"
                value={profileInfo.nextOfKinNumber}
                placeholder={loggedInUser.currentUser.nextOfKinNumber}
                onChange={handleProfileChange}
              />

                        <FormField
                label="next of kin address"
                name="nextOfKinAddress"
                type="text"
                value={profileInfo.nextOfKinAddress}
                placeholder={loggedInUser.currentUser.nextOfKinAddress}
                onChange={handleProfileChange}
              />

                     <FormField
                label="next of kin relationship"
                name="nextOfKinRelationship"
                type="text"
                value={profileInfo.nextOfKinRelationship}
                placeholder={loggedInUser.currentUser.nextOfKinRelationship}
                onChange={handleProfileChange}
              />


                </>
              )  }
                

            </div>
            
         
            
               
       
        

            {/* Additional Information */}
            <div className="space-y-4">
              <FormField
                label="Last Name"
                name="lastName"
                type="text"
                value={profileInfo.lastName}
                placeholder={loggedInUser.currentUser.lastName}
                onChange={handleProfileChange}
              />
              <FormField
                label="Phone Number"
                name="phoneNumber"
                type="tel"
                value={profileInfo.phoneNumber}
                placeholder={loggedInUser.currentUser.phoneNumber}
                onChange={handleProfileChange}
              />
              <FormField
                label="Whatsapp Number"
                name="whatsappNumber"
                type="tel"
                value={profileInfo.whatsappNumber}
                placeholder={loggedInUser.currentUser.whatsappNumber}
                onChange={handleProfileChange}
              />
              <FormField
                label="Job decision salary"
                name="jobDecisionSalary"
                type="text"
                value={profileInfo.jobDecisionSalary}
                placeholder={loggedInUser.currentUser.jobDecisionSalary}
                onChange={handleProfileChange}
              />
              <SelectField
                label="Race"
                name="race"
                value={profileInfo.race}
                onChange={handleProfileChange}
                options={race}
              />
              <SelectField
                label="Disability"
                name="disability"
                value={profileInfo.disability}
                onChange={handleProfileChange}
                options={["No", "Yes"]}
              />
              <SelectField
                label="have any criminal record?"
                name="criminalRecord"
                value={profileInfo.criminalRecord}
                onChange={handleProfileChange}
                options={["No", "Yes"]}
              />
                  <SelectField
                label="highest educational level?"
                name="educationLevel"
                value={profileInfo.educationLevel}
                onChange={handleProfileChange}
                options={["PHD", "masters", "graduate", "undergraduate", "SSCE", "others"]}
              />
              


              {profileInfo.criminalRecord === "Yes" && (
                <>
                   <FormField
                label="when was it"
                name="when"
                type="date"
                value={profileInfo.when}
                placeholder={loggedInUser.currentUser.when}
                onChange={handleProfileChange}
              />
                   <FormField
                label="where was it"
                name="where"
                type="text"
                value={profileInfo.where}
                placeholder={loggedInUser.currentUser.where}
                onChange={handleProfileChange}
              />
                   <FormField
                label="what was the incident"
                name="incident"
                type="text"
                value={profileInfo.incident}
                placeholder={loggedInUser.currentUser.incident}
                onChange={handleProfileChange}
              />
                <SelectField
                label="nature of offence?"
                name="natureOfOffence"
                value={profileInfo.natureOfOffence}
                onChange={handleProfileChange}
                options={["murder", "rape", "stealing", "others"]}
              />
            
                

                </>
              )}
              <SelectField
                label="any child?"
                name="anyChild"
                value={profileInfo.anyChild}
                onChange={handleProfileChange}
                options={["No", "Yes",]}
              />

              {profileInfo.anyChild === "Yes" && (
                <>
                       <FormField
                label="how many children"
                name="numberOfChildren"
                type="text"
                value={profileInfo.numberOfChildren}
                placeholder={loggedInUser.currentUser.numberOfChildren}
                onChange={handleProfileChange}
              />
                </>
              )}

                <SelectField
                label="any vocational skill?"
                name="handworkSkill"
                value={profileInfo.handworkSkill}
                onChange={handleProfileChange}
                options={["No", "Yes",]}
              />


              {profileInfo.handworkSkill === "Yes" && (
                        <FormField
                label="please specify"
                name="specifyHandworkSkill"
                type="text"
                value={profileInfo.specifyHandworkSkill}
                placeholder={loggedInUser.currentUser.specifyHandworkSkill}
                onChange={handleProfileChange}
              />
              )
              }

               <SelectField
                label="what kind of work do you prefer"
                name="workingMode"
                value={profileInfo.workingMode}
                onChange={handleProfileChange}
                options={["work with accommodation and open for relocation", 
                "work without accommodation and open for relocation",
                "work with accommodation and not open for relocation",
                "work without accommodation and not open for relocation"
                ]}

                
              />

                   <FormField
                label="what is the minimum salary you expect"
                name="minimumSalary"
                type="text"
                value={profileInfo.minimumSalary}
                placeholder={loggedInUser.currentUser.minimumSalary}
                onChange={handleProfileChange}
              />

                 <FormField
                label="what is the least salary you expect"
                name="leastSalary"
                type="text"
                value={profileInfo.leastSalary}
                placeholder={loggedInUser.currentUser.leastSalary}
                onChange={handleProfileChange}
              />
                 <FormField
                label="facebookHandle"
                name="facebookHandle"
                type="text"
                value={profileInfo.facebookHandle}
                placeholder={loggedInUser.currentUser.facebookHandle}
                onChange={handleProfileChange}
              />
                 {/* <FormField
                label="NIN"
                name="nin"
                type="text"
                value={profileInfo.nin}
                placeholder={loggedInUser.currentUser.nin}
                onChange={handleProfileChange}
              /> */}

                  <div className="flex items-end gap-2">
                <FormField
                  label="NIN"
                  name="nin"
                  type="text"
                  value={profileInfo.nin}
                  placeholder={loggedInUser.currentUser.nin || "Enter your NIN"}
                  onChange={handleProfileChange}
                />
                <button
                  onClick={handleVerifyNIN}
                  disabled={loadingNINVerification || userDetails?.isNINVerified}
                  className={`p-2 rounded-md text-white ${
                    loadingNINVerification || userDetails?.isNINVerified
                      ? 'bg-gray-400 cursor-not-allowed'
                      : 'bg-blue-500 hover:bg-blue-600'
                  }`}
                >
                  {loadingNINVerification ? <Spinner /> : userDetails?.isNINVerified ? 'Verified' : 'Verify NIN'}
                </button>
              </div>
              {ninVerificationStatus?.status === 'success' && (
                <div className="mt-2 p-4 bg-green-100 rounded">
                  <p><strong>Verified Name:</strong> {ninVerificationStatus.data.firstName} {ninVerificationStatus.data.lastName}</p>
                  <p><strong>Date of Birth:</strong> {ninVerificationStatus.data.dateOfBirth}</p>
                  <p><strong>NIN:</strong> ****</p>
                </div>
              )}
              {ninVerificationStatus?.status === 'error' && (
                <p className="mt-2 text-red-500">{ninVerificationStatus.message}</p>
              )}
              

                   <FormField
                label="Bank Name"
                name="bankName"
                type="text"
                value={profileInfo.bankName}
                placeholder={loggedInUser.currentUser.bankName}
                onChange={handleProfileChange}
              />

              {profileInfo.bankName !== '' && (
                <>
                   <FormField
                label="Bank Acct Name"
                name="bankAcctName"
                type="text"
                value={profileInfo.bankAcctName}
                placeholder={loggedInUser.currentUser.bankAcctName}
                onChange={handleProfileChange}
              />
                   <FormField
                label="Bank Acct Num"
                name="bankAcctNum"
                type="text"
                value={profileInfo.bankAcctNum}
                placeholder={loggedInUser.currentUser.bankAcctNum}
                onChange={handleProfileChange}
              />
                </>
              )}

           
             

            </div>
          </div>

          {changeListener && (
            <div className="mt-6 text-center">
              <button
                onClick={handleUpdate}
                disabled={loadingUpdate}
                className="px-6 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors disabled:opacity-50"
              >
                {loadingUpdate ? <LoadSpinner /> : "Save Changes"}
              </button>
            </div>
          )}
        </div>

        {/* ---- Education ---- */}
        <div className="bg-white rounded-lg shadow-sm p-6 mb-8">
          <EducationList
            refetch={refetchUser}
            userEducation={userDetails?.education}
          />
        </div>

        <div className="bg-white rounded-lg shadow-sm p-6 mb-8">
          <WorkExperienceList
            userExperience={userDetails?.workExperience}
            refetch={refetchUser}
          />
        </div>

        {/* ---- Guarantor ---- */}
        <div className="bg-white rounded-lg shadow-sm p-6 mb-8">
          <ContactList
            userGuarantors={userDetails?.guarantors}
            refetch={refetchUser}
          />
        </div>

        <div className="bg-white rounded-lg shadow-sm p-6 mb-8">
          <Certificate
            userCertificate={userDetails?.certificates}
            refetch={refetchUser}
          />
        </div>

        {/* applications */}
        <div className="bg-white rounded-lg shadow-sm p-6 mb-8">
          <ApplicationTable userApplication={userDetails?.appliedJobs} />
        </div>

        {/* employment */}
        <div className="bg-white rounded-lg shadow-sm p-6 mb-8">
          <EmploymentRecord jobRecord={userDetails?.appliedJobs} />
        </div>


        <Search />
        <SearchDashboard />
        <h1 className="font-bold text-xl">You are seeing urgent request staff details because you are a certified jobseeker which means you have gone through our 2 weeks training</h1>

        {/* <JobSeekerAvailabilityUpdate/> */}
        {/* <UrgentJobSeekerAccept /> */}
          {userDetails?.isCertified && <UrgentJobSeekerAccept />}

        {/* Notification */}
        <div className="bg-white rounded-lg shadow-sm p-6 mb-8">
        <JobSeekerNotification jobSeeker={userDetails} />;

        <EmployerEmployeeJobSeeker />

        <BenefitHistory />
        <JobSeekerBenefits/>
        <BenefitSummary />
      
         
        </div>
      </div>

      <FooterComponent />
    </div>
  );
};

// Helper Components
const FormField = ({ label, name, type, value, placeholder, onChange }) => (
  <div className="space-y-1">
    <label htmlFor={name} className="block text-sm font-medium text-gray-700">
      {label}
    </label>
    <input
      type={type}
      name={name}
      id={name}
      value={value || ""}
      onChange={onChange}
      placeholder={placeholder}
      className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
    />
  </div>
);

const SelectField = ({ label, name, value, onChange, options }) => (
  <div className="space-y-1">
    <label htmlFor={name} className="block text-sm font-medium text-gray-700">
      {label}
    </label>
    <select
      name={name}
      id={name}
      value={value || ""}
      onChange={onChange}
      className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
    >
      <option value="">Select {label}</option>
      {options?.map((option) => (
        <option key={option} value={option}>
          {option}
        </option>
      ))}
    </select>
  </div>
);

export default ProfilePages;
































































































































































// import React, { useRef, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { MdCancel, MdInfoOutline } from "react-icons/md";
// import { FaCamera } from "react-icons/fa6";
// import axios from "axios";
// import { toast } from "sonner";
// import { updateUser } from "../../redux/users/userSlice";
// import { useFetchData } from "../../hooks/useFtechData";
// import {
//   APPLICATION_API,
//   CERTIFICATE_URL,
//   EDUCATION_URL,
//   GUARANTOR_URL,
//   JOBSEEKER_URL,
//   WORK_URL,
// } from "../../resources/resource";
// import { convertToBase64 } from "../../Utils/fileConverter";
// import Header from "../../component/Header";
// import FooterComponent from "../../component/Footer";
// import LoadSpinner from "../../component/Modals/LoadSpinner";
// import DefaultProfile from "../../assets/Images/employee.png";
// import WorkExperienceList from "./Work";
// import EducationList from "./Education";
// import ContactList from "./ContactPerson";
// import ApplicationTable from "./Application";
// import EmploymentRecord from "./Employment";
// import Certificate from "./Certificate";
// import { useMakeRequest } from "../../hooks/useMakeRequest";
// import { uploadToCloudinary } from "../../Utils/cloudinaryUpload";
// import { Spinner } from "flowbite-react";
// import { race } from "./data";
// import JobSeekerNotification from "./JobSeekerNotifications";
// import Search from "../../component/Search";
// import SearchDashboard from "../Employer/SearchDashboard";
// import EmployerEmployeeJobSeeker from "./EmployerEmployeeJobSeeker";
// import EmployeeAttendance from "./EmployeeAttendance";
// import BenefitHistory from "./BenefitHistory";
// import JobSeekerBenefits from "./JobSeekerBenefit";
// import BenefitSummary from "./BenefitSumarry";
// import FaceAuth from "./FaceAuth";
// import JobSeekerAvailabilityUpdate from "./JobseekerAvailabilityUpdates";
// import UrgentJobSeekerAccept from "./UrgentJobSeekerAccept";

// const ProfilePages = () => {
//   const dispatch = useDispatch();
//   const { currentUser, token } = useSelector((state) => state.user);
//   const loggedInUser = useSelector((state) => state.user);
//   const fileInputRef = useRef();
//   const makeRequest = useMakeRequest();
//   const votersCardInputRef = useRef();
//   const residentialCardInputRef = useRef();
//   const scanningEvidenceInputRef = useRef();
//   const tenancyAgreementInputRef = useRef();

//   const { data: userDetails, refetch: refetchUser } = useFetchData(
//     JOBSEEKER_URL + `/getAjobSeeker/${loggedInUser?.currentUser?._id}`
//   );

//   const [changeListener, setChangeListener] = useState(false);
//   const [loadingUpdate, setLoadingUpdate] = useState(false);
//   const [loadingImageUpload, setLoadingImageUpload] = useState(false);
//   const [loadingNINVerification, setLoadingNINVerification] = useState(false);
//   const [ninVerificationStatus, setNINVerificationStatus] = useState(null);
//   const [previewImage, setPreviewImage] = useState(null);
//   const [votersCardPreview, setVotersCardPreview] = useState(null);
//   const [residentialCardPreview, setResidentialCardPreview] = useState(null);
//   const [scanningEvidencePreview, setScanningEvidencePreview] = useState(null);
//   const [tenancyAgreementPreview, setTenancyAgreementPreview] = useState(null);
//   const [imageChange, setImageChange] = useState(false);
//   const [votersCard, setVotersCard] = useState(null);
//   const [residentialCard, setResidentialCard] = useState(null);
//   const [scanningEvidence, setScanningEvidence] = useState(null);
//   const [tenancyAgreement, setTenancyAgreement] = useState(null);
//   const [imageFile, setImageFile] = useState(null);
//   const [faceData, setFaceData] = useState(null);
//   const [profileInfo, setProfileInfo] = useState({
//     jobSeekerId: loggedInUser?.currentUser?._id,
//     nin: '',
//   });

//   const handleProfileChange = (e) => {
//     setProfileInfo({
//       ...profileInfo,
//       [e.target.name]: e.target.value,
//       jobSeekerId: loggedInUser.currentUser._id,
//     });
//     setChangeListener(true);
//   };

//   const handleAvatar = async (e, fileType) => {
//     const file = e.target.files[0];
//     if (!file) return;

//     switch (fileType) {
//       case "avatar":
//         setImageFile(file);
//         setPreviewImage(URL.createObjectURL(file));
//         break;
//       case "votersCard":
//         setVotersCard(file);
//         setVotersCardPreview(URL.createObjectURL(file));
//         break;
//       case "residentialCard":
//         setResidentialCard(file);
//         setResidentialCardPreview(URL.createObjectURL(file));
//         break;
//       case "scanningEvidence":
//         setScanningEvidence(file);
//         setScanningEvidencePreview(URL.createObjectURL(file));
//         break;
//       case "tenancyAgreement":
//         setTenancyAgreement(file);
//         setTenancyAgreementPreview(URL.createObjectURL(file));
//         break;
//       default:
//         break;
//     }
//     setImageChange(true);
//   };

//   const handleUpdateImage = async () => {
//     if (!imageFile && !votersCard && !residentialCard && !scanningEvidence && !tenancyAgreement && !faceData) {
//       return toast.error('Kindly select at least one file or complete face authentication to upload');
//     }
//     setLoadingImageUpload(true);
//     try {
//       const payload = {};
//       if (imageFile) {
//         const imageURL = await uploadToCloudinary(imageFile);
//         if (imageURL) payload.avatar = imageURL;
//       }
//       if (votersCard) {
//         const votersCardURL = await uploadToCloudinary(votersCard);
//         if (votersCardURL) payload.votersCard = votersCardURL;
//       }
//       if (residentialCard) {
//         const residentialCardURL = await uploadToCloudinary(residentialCard);
//         if (residentialCardURL) payload.residentialCard = residentialCardURL;
//       }
//       if (scanningEvidence) {
//         const scanningEvidenceURL = await uploadToCloudinary(scanningEvidence);
//         if (scanningEvidenceURL) payload.scanningEvidence = scanningEvidenceURL;
//       }
//       if (tenancyAgreement) {
//         const tenancyAgreementURL = await uploadToCloudinary(tenancyAgreement);
//         if (tenancyAgreementURL) payload.tenancyAgreement = tenancyAgreementURL;
//       }
//       if (faceData) {
//         payload.faceData = JSON.stringify(faceData);
//       }

//       if (Object.keys(payload).length === 0) {
//         return toast.error("Error uploading files");
//       }

//       makeRequest(
//         JOBSEEKER_URL + `/updateJobSeeker/${loggedInUser?.currentUser?._id}`,
//         "PUT",
//         payload,
//         (data) => {
//           refetchUser();
//           toast.success("Files uploaded successfully");
//         },
//         (error) => {
//           console.log(error || "Error updating files");
//           toast.error("Error updating files");
//         },
//         () => {
//           setImageChange(false);
//           setLoadingImageUpload(false);
//         }
//       );
//     } catch (error) {
//       toast.error("Unknown error, please try again later");
//       setLoadingImageUpload(false);
//     }
//   };

//   const handleUpdate = async () => {
//     setLoadingUpdate(true);
//     makeRequest(
//       JOBSEEKER_URL + `/updateJobSeeker/${loggedInUser?.currentUser?._id}`,
//       "PUT",
//       profileInfo,
//       (data) => {
//         dispatch(updateUser({ ...loggedInUser.currentUser, ...data.user }));
//         refetchUser();
//         toast.success("Profile updated successfully");
//       },
//       (error) => {
//         console.log(error);
//         toast.error(error?.msg || "Error updating profile");
//       },
//       () => {
//         setLoadingUpdate(false);
//         setChangeListener(false);
//       }
//     );
//   };

//   const handleVerifyNIN = async () => {
//     if (!profileInfo.nin || !/^\d{11}$/.test(profileInfo.nin)) {
//       toast.error("Please enter a valid 11-digit NIN");
//       return;
//     }

//     setLoadingNINVerification(true);
//     try {
//       const response = await axios.post(
//         `${JOBSEEKER_URL}/verify-nin`,
//         { nin: profileInfo.nin },
//         {
//           headers: { Authorization: `Bearer ${token}` },
//         }
//       );

//       setNINVerificationStatus({
//         status: 'success',
//         data: response.data.verifiedData,
//       });
//       dispatch(updateUser({
//         ...loggedInUser.currentUser,
//         nin: response.data.verifiedData.nin,
//         isNINVerified: true,
//         firstName: response.data.verifiedData.firstName || loggedInUser.currentUser.firstName,
//         lastName: response.data.verifiedData.lastName || loggedInUser.currentUser.lastName,
//         dateOfBirth: response.data.verifiedData.dateOfBirth || loggedInUser.currentUser.dateOfBirth,
//       }));
//       toast.success("NIN verified successfully");
//     } catch (error) {
//       setNINVerificationStatus({
//         status: 'error',
//         message: error.response?.data?.msg || "Error verifying NIN",
//       });
//       toast.error(error.response?.data?.msg || "Error verifying NIN");
//     } finally {
//       setLoadingNINVerification(false);
//     }
//   };

//   return (
//     <div className="min-h-screen bg-gray-50 pt-16 sm:pt-20">
//       <Header darkMode={true} />
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
//         <div className="bg-white rounded-lg shadow-sm p-6 mb-8">
//           <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
//             <div className="space-y-6">
//               <label>Your profile picture</label>
//               <div className="relative flex items-center">
//                 <img
//                   src={previewImage || userDetails?.avatar || DefaultProfile}
//                   alt="Profile"
//                   className="w-32 h-32 rounded-full object-cover border-4 border-gray-100 shadow-sm"
//                 />
//                 <button
//                   onClick={() => fileInputRef.current.click()}
//                   className="absolute bottom-0 left-0 p-2 bg-white rounded-full shadow-lg hover:bg-gray-50 transition-colors"
//                 >
//                   <FaCamera className="text-gray-600" />
//                 </button>
//                 <input
//                   ref={fileInputRef}
//                   type="file"
//                   name="avatar"
//                   onChange={(e) => handleAvatar(e, "avatar")}
//                   className="hidden"
//                 />
//                 {imageChange ? (
//                   <button
//                     onClick={handleUpdateImage}
//                     className="bg-green-400 ml-2 hover:bg-green-500 text-white p-[3px] rounded-sm"
//                   >
//                     {loadingImageUpload ? <Spinner /> : "Upload"}
//                   </button>
//                 ) : null}
//               </div>
//               <label>Face Authentication</label>
//               <FaceAuth onFaceData={setFaceData} token={token} />
//               <label className="mt-3">Your Voters card</label>
//               <div className="relative flex items-center">
//                 <img
//                   src={votersCardPreview || userDetails?.votersCard || DefaultProfile}
//                   alt="Voter's Card"
//                   className="w-32 h-32 rounded-full object-cover border-4 border-gray-100 shadow-sm"
//                 />
//                 <button
//                   onClick={() => votersCardInputRef.current.click()}
//                   className="absolute bottom-0 left-0 p-2 bg-white rounded-full shadow-lg hover:bg-gray-50 transition-colors"
//                 >
//                   <FaCamera className="text-gray-600" />
//                 </button>
//                 <input
//                   ref={votersCardInputRef}
//                   type="file"
//                   name="votersCard"
//                   onChange={(e) => handleAvatar(e, "votersCard")}
//                   className="hidden"
//                 />
//               </div>
//               <label className="mt-3">Your residential card</label>
//               <div className="relative flex items-center">
//                 <img
//                   src={residentialCardPreview || userDetails?.residentialCard || DefaultProfile}
//                   alt="Residential Card"
//                   className="w-32 h-32 rounded-full object-cover border-4 border-gray-100 shadow-sm"
//                 />
//                 <button
//                   onClick={() => residentialCardInputRef.current.click()}
//                   className="absolute bottom-0 left-0 p-2 bg-white rounded-full shadow-lg hover:bg-gray-50 transition-colors"
//                 >
//                   <FaCamera className="text-gray-600" />
//                 </button>
//                 <input
//                   ref={residentialCardInputRef}
//                   type="file"
//                   name="residentialCard"
//                   onChange={(e) => handleAvatar(e, "residentialCard")}
//                   className="hidden"
//                 />
//               </div>
//               <label className="mt-3">Your scanning evidence</label>
//               <div className="relative flex items-center">
//                 <img
//                   src={scanningEvidencePreview || userDetails?.scanningEvidence || DefaultProfile}
//                   alt="Scanning Evidence"
//                   className="w-32 h-32 rounded-full object-cover border-4 border-gray-100 shadow-sm"
//                 />
//                 <button
//                   onClick={() => scanningEvidenceInputRef.current.click()}
//                   className="absolute bottom-0 left-0 p-2 bg-white rounded-full shadow-lg hover:bg-gray-50 transition-colors"
//                 >
//                   <FaCamera className="text-gray-600" />
//                 </button>
//                 <input
//                   ref={scanningEvidenceInputRef}
//                   type="file"
//                   name="scanningEvidence"
//                   onChange={(e) => handleAvatar(e, "scanningEvidence")}
//                   className="hidden"
//                 />
//               </div>
//               <label className="mt-3">Your tenancy agreement</label>
//               <div className="relative flex items-center">
//                 <img
//                   src={tenancyAgreementPreview || userDetails?.tenancyAgreement || DefaultProfile}
//                   alt="Tenancy Agreement"
//                   className="w-32 h-32 rounded-full object-cover border-4 border-gray-100 shadow-sm"
//                 />
//                 <button
//                   onClick={() => tenancyAgreementInputRef.current.click()}
//                   className="absolute bottom-0 left-0 p-2 bg-white rounded-full shadow-lg hover:bg-gray-50 transition-colors"
//                 >
//                   <FaCamera className="text-gray-600" />
//                 </button>
//                 <input
//                   ref={tenancyAgreementInputRef}
//                   type="file"
//                   name="tenancyAgreement"
//                   onChange={(e) => handleAvatar(e, "tenancyAgreement")}
//                   className="hidden"
//                 />
//               </div>
//               <div className="p-4 bg-gray-50 rounded-lg border border-gray-200">
//                 <h3 className="font-medium text-gray-900 mb-2">Primary Address</h3>
//                 <p className="text-gray-600">
//                   {loggedInUser.currentUser.address || "No address provided"}
//                 </p>
//               </div>
//             </div>
//             <div className="space-y-4">
//               <FormField
//                 label="First Name"
//                 name="firstName"
//                 type="text"
//                 value={profileInfo.firstName}
//                 placeholder={loggedInUser.currentUser.firstName}
//                 onChange={handleProfileChange}
//               />
//               <FormField
//                 label="Email"
//                 name="email"
//                 type="email"
//                 value={profileInfo.email}
//                 placeholder={loggedInUser.currentUser.email}
//                 onChange={handleProfileChange}
//               />
//               <FormField
//                 label="Date of Birth"
//                 name="dateOfBirth"
//                 type="date"
//                 placeholder={loggedInUser.currentUser.dateOfBirth}
//                 value={profileInfo.dateOfBirth}
//                 onChange={handleProfileChange}
//               />
//               <SelectField
//                 label="Gender"
//                 name="gender"
//                 placeholder={loggedInUser.currentUser.gender}
//                 value={profileInfo.gender}
//                 onChange={handleProfileChange}
//                 options={["male", "female"]}
//               />
//               <SelectField
//                 label="Job Decision"
//                 name="jobDecision"
//                 placeholder={loggedInUser.currentUser.jobDecision}
//                 value={profileInfo.jobDecision}
//                 onChange={handleProfileChange}
//                 options={["job-seeker", "job-changer"]}
//               />
//               <SelectField
//                 label="Do you live alone"
//                 name="liveAlone"
//                 value={profileInfo.liveAlone}
//                 onChange={handleProfileChange}
//                 options={["Yes", "No"]}
//               />
//               {profileInfo.liveAlone === "No" && (
//                 <FormField
//                   label="Who do you live with"
//                   name="whoDoYouLiveWith"
//                   type="text"
//                   value={profileInfo.whoDoYouLiveWith}
//                   onChange={handleProfileChange}
//                 />
//               )}
//               <FormField
//                 label="How much is your rent"
//                 name="rentfee"
//                 type="text"
//                 placeholder={loggedInUser.currentUser.rentfee}
//                 value={profileInfo.rentfee}
//                 onChange={handleProfileChange}
//               />
//               <FormField
//                 label="Landlord or Agent Number"
//                 name="landlordNumber"
//                 type="text"
//                 value={profileInfo.landlordNumber}
//                 placeholder={loggedInUser.currentUser.landlordNumber}
//                 onChange={handleProfileChange}
//               />
//               <FormField
//                 label="Number of Rooms"
//                 name="numberOfRooms"
//                 type="text"
//                 value={profileInfo.numberOfRooms}
//                 placeholder={loggedInUser.currentUser.numberOfRooms}
//                 onChange={handleProfileChange}
//               />
//               <FormField
//                 label="Number of people living in the house"
//                 name="numberOfPeople"
//                 type="text"
//                 value={profileInfo.numberOfPeople}
//                 placeholder={loggedInUser.currentUser.numberOfPeople}
//                 onChange={handleProfileChange}
//               />
//               <FormField
//                 label="TikTok Handle"
//                 name="tiktokHandle"
//                 type="text"
//                 value={profileInfo.tiktokHandle}
//                 placeholder={loggedInUser.currentUser.tiktokHandle}
//                 onChange={handleProfileChange}
//               />
//               <FormField
//                 label="Instagram Handle"
//                 name="instagramHandle"
//                 type="text"
//                 value={profileInfo.instagramHandle}
//                 placeholder={loggedInUser.currentUser.instagramHandle}
//                 onChange={handleProfileChange}
//               />
//               <SelectField
//                 label="Registered with E-Verify?"
//                 name="registeredEverify"
//                 value={profileInfo.registeredEverify}
//                 onChange={handleProfileChange}
//                 options={["No", "Yes"]}
//               />
//               <FormField
//                 label="Next of Kin Name"
//                 name="nextOfKin"
//                 type="text"
//                 value={profileInfo.nextOfKin}
//                 placeholder={loggedInUser.currentUser.nextOfKin}
//                 onChange={handleProfileChange}
//               />
//               <SelectField
//                 label="Marital Status"
//                 name="maritalStatus"
//                 value={profileInfo.maritalStatus}
//                 onChange={handleProfileChange}
//                 options={["single", "married", "divorce", "widow", "widower", "separated"]}
//               />
//               {profileInfo.nextOfKin && (
//                 <>
//                   <FormField
//                     label="Next of Kin Phone Number"
//                     name="nextOfKinNumber"
//                     type="number"
//                     value={profileInfo.nextOfKinNumber}
//                     placeholder={loggedInUser.currentUser.nextOfKinNumber}
//                     onChange={handleProfileChange}
//                   />
//                   <FormField
//                     label="Next of Kin Address"
//                     name="nextOfKinAddress"
//                     type="text"
//                     value={profileInfo.nextOfKinAddress}
//                     placeholder={loggedInUser.currentUser.nextOfKinAddress}
//                     onChange={handleProfileChange}
//                   />
//                   <FormField
//                     label="Next of Kin Relationship"
//                     name="nextOfKinRelationship"
//                     type="text"
//                     value={profileInfo.nextOfKinRelationship}
//                     placeholder={loggedInUser.currentUser.nextOfKinRelationship}
//                     onChange={handleProfileChange}
//                   />
//                 </>
//               )}
//             </div>
//             <div className="space-y-4">
//               <FormField
//                 label="Last Name"
//                 name="lastName"
//                 type="text"
//                 value={profileInfo.lastName}
//                 placeholder={loggedInUser.currentUser.lastName}
//                 onChange={handleProfileChange}
//               />
//               <FormField
//                 label="Phone Number"
//                 name="phoneNumber"
//                 type="tel"
//                 value={profileInfo.phoneNumber}
//                 placeholder={loggedInUser.currentUser.phoneNumber}
//                 onChange={handleProfileChange}
//               />
//               <FormField
//                 label="Whatsapp Number"
//                 name="whatsappNumber"
//                 type="tel"
//                 value={profileInfo.whatsappNumber}
//                 placeholder={loggedInUser.currentUser.whatsappNumber}
//                 onChange={handleProfileChange}
//               />
//               <FormField
//                 label="Job Decision Salary"
//                 name="jobDecisionSalary"
//                 type="text"
//                 value={profileInfo.jobDecisionSalary}
//                 placeholder={loggedInUser.currentUser.jobDecisionSalary}
//                 onChange={handleProfileChange}
//               />
//               <SelectField
//                 label="Race"
//                 name="race"
//                 value={profileInfo.race}
//                 onChange={handleProfileChange}
//                 options={race}
//               />
//               <SelectField
//                 label="Disability"
//                 name="disability"
//                 value={profileInfo.disability}
//                 onChange={handleProfileChange}
//                 options={["No", "Yes"]}
//               />
//               <SelectField
//                 label="Have any criminal record?"
//                 name="criminalRecord"
//                 value={profileInfo.criminalRecord}
//                 onChange={handleProfileChange}
//                 options={["No", "Yes"]}
//               />
//               {profileInfo.criminalRecord === "Yes" && (
//                 <>
//                   <FormField
//                     label="When was it"
//                     name="when"
//                     type="date"
//                     value={profileInfo.when}
//                     placeholder={loggedInUser.currentUser.when}
//                     onChange={handleProfileChange}
//                   />
//                   <FormField
//                     label="Where was it"
//                     name="where"
//                     type="text"
//                     value={profileInfo.where}
//                     placeholder={loggedInUser.currentUser.where}
//                     onChange={handleProfileChange}
//                   />
//                   <FormField
//                     label="What was the incident"
//                     name="incident"
//                     type="text"
//                     value={profileInfo.incident}
//                     placeholder={loggedInUser.currentUser.incident}
//                     onChange={handleProfileChange}
//                   />
//                   <SelectField
//                     label="Nature of Offence"
//                     name="natureOfOffence"
//                     value={profileInfo.natureOfOffence}
//                     onChange={handleProfileChange}
//                     options={["murder", "rape", "stealing", "others"]}
//                   />
//                 </>
//               )}
//               <SelectField
//                 label="Any child?"
//                 name="anyChild"
//                 value={profileInfo.anyChild}
//                 onChange={handleProfileChange}
//                 options={["No", "Yes"]}
//               />
//               {profileInfo.anyChild === "Yes" && (
//                 <FormField
//                   label="How many children"
//                   name="numberOfChildren"
//                   type="text"
//                   value={profileInfo.numberOfChildren}
//                   placeholder={loggedInUser.currentUser.numberOfChildren}
//                   onChange={handleProfileChange}
//                 />
//               )}
//               <SelectField
//                 label="Any vocational skill?"
//                 name="handworkSkill"
//                 value={profileInfo.handworkSkill}
//                 onChange={handleProfileChange}
//                 options={["No", "Yes"]}
//               />
//               {profileInfo.handworkSkill === "Yes" && (
//                 <FormField
//                   label="Please specify"
//                   name="specifyHandworkSkill"
//                   type="text"
//                   value={profileInfo.specifyHandworkSkill}
//                   placeholder={loggedInUser.currentUser.specifyHandworkSkill}
//                   onChange={handleProfileChange}
//                 />
//               )}
//               <SelectField
//                 label="What kind of work do you prefer"
//                 name="workingMode"
//                 value={profileInfo.workingMode}
//                 onChange={handleProfileChange}
//                 options={[
//                   "work with accommodation and open for relocation",
//                   "work without accommodation and open for relocation",
//                   "work with accommodation and not open for relocation",
//                   "work without accommodation and not open for relocation",
//                 ]}
//               />
//               <FormField
//                 label="What is the minimum salary you expect"
//                 name="minimumSalary"
//                 type="text"
//                 value={profileInfo.minimumSalary}
//                 placeholder={loggedInUser.currentUser.minimumSalary}
//                 onChange={handleProfileChange}
//               />
//               <FormField
//                 label="What is the least salary you expect"
//                 name="leastSalary"
//                 type="text"
//                 value={profileInfo.leastSalary}
//                 placeholder={loggedInUser.currentUser.leastSalary}
//                 onChange={handleProfileChange}
//               />
//               <FormField
//                 label="Facebook Handle"
//                 name="facebookHandle"
//                 type="text"
//                 value={profileInfo.facebookHandle}
//                 placeholder={loggedInUser.currentUser.facebookHandle}
//                 onChange={handleProfileChange}
//               />
//               <div className="flex items-end gap-2">
//                 <FormField
//                   label="NIN"
//                   name="nin"
//                   type="text"
//                   value={profileInfo.nin}
//                   placeholder={loggedInUser.currentUser.nin || "Enter your NIN"}
//                   onChange={handleProfileChange}
//                 />
//                 <button
//                   onClick={handleVerifyNIN}
//                   disabled={loadingNINVerification || userDetails?.isNINVerified}
//                   className={`p-2 rounded-md text-white ${
//                     loadingNINVerification || userDetails?.isNINVerified
//                       ? 'bg-gray-400 cursor-not-allowed'
//                       : 'bg-blue-500 hover:bg-blue-600'
//                   }`}
//                 >
//                   {loadingNINVerification ? <Spinner /> : userDetails?.isNINVerified ? 'Verified' : 'Verify NIN'}
//                 </button>
//               </div>
//               {ninVerificationStatus?.status === 'success' && (
//                 <div className="mt-2 p-4 bg-green-100 rounded">
//                   <p><strong>Verified Name:</strong> {ninVerificationStatus.data.firstName} {ninVerificationStatus.data.lastName}</p>
//                   <p><strong>Date of Birth:</strong> {ninVerificationStatus.data.dateOfBirth}</p>
//                   <p><strong>NIN:</strong> ****</p>
//                 </div>
//               )}
//               {ninVerificationStatus?.status === 'error' && (
//                 <p className="mt-2 text-red-500">{ninVerificationStatus.message}</p>
//               )}
//               <FormField
//                 label="Bank Name"
//                 name="bankName"
//                 type="text"
//                 value={profileInfo.bankName}
//                 placeholder={loggedInUser.currentUser.bankName}
//                 onChange={handleProfileChange}
//               />
//               {profileInfo.bankName && (
//                 <>
//                   <FormField
//                     label="Bank Account Name"
//                     name="bankAcctName"
//                     type="text"
//                     value={profileInfo.bankAcctName}
//                     placeholder={loggedInUser.currentUser.bankAcctName}
//                     onChange={handleProfileChange}
//                   />
//                   <FormField
//                     label="Bank Account Number"
//                     name="bankAcctNum"
//                     type="text"
//                     value={profileInfo.bankAcctNum}
//                     placeholder={loggedInUser.currentUser.bankAcctNum}
//                     onChange={handleProfileChange}
//                   />
//                 </>
//               )}
//             </div>
//           </div>
//           {changeListener && (
//             <div className="mt-6 text-center">
//               <button
//                 onClick={handleUpdate}
//                 disabled={loadingUpdate}
//                 className="px-6 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors disabled:opacity-50"
//               >
//                 {loadingUpdate ? <LoadSpinner /> : "Save Changes"}
//               </button>
//             </div>
//           )}
//         </div>
//         <div className="bg-white rounded-lg shadow-sm p-6 mb-8">
//           <EducationList
//             refetch={refetchUser}
//             userEducation={userDetails?.education}
//           />
//         </div>
//         <div className="bg-white rounded-lg shadow-sm p-6 mb-8">
//           <WorkExperienceList
//             userExperience={userDetails?.workExperience}
//             refetch={refetchUser}
//           />
//         </div>
//         <div className="bg-white rounded-lg shadow-sm p-6 mb-8">
//           <ContactList
//             userGuarantors={userDetails?.guarantors}
//             refetch={refetchUser}
//           />
//         </div>
//         <div className="bg-white rounded-lg shadow-sm p-6 mb-8">
//           <Certificate
//             userCertificate={userDetails?.certificates}
//             refetch={refetchUser}
//           />
//         </div>
//         <div className="bg-white rounded-lg shadow-sm p-6 mb-8">
//           <ApplicationTable userApplication={userDetails?.appliedJobs} />
//         </div>
//         <div className="bg-white rounded-lg shadow-sm p-6 mb-8">
//           <EmploymentRecord jobRecord={userDetails?.appliedJobs} />
//         </div>
//         <Search />
//         <SearchDashboard />
//         <h1 className="font-bold text-xl">You are seeing urgent request staff details because you are a certified jobseeker which means you have gone through our 2 weeks training</h1>
//         {userDetails?.isCertified && <UrgentJobSeekerAccept />}
//         <div className="bg-white rounded-lg shadow-sm p-6 mb-8">
//           <JobSeekerNotification jobSeeker={userDetails} />
//           <EmployerEmployeeJobSeeker />
//           <BenefitHistory />
//           <JobSeekerBenefits />
//           <BenefitSummary />
//         </div>
//       </div>
//       <FooterComponent />
//     </div>
//   );
// };

// const FormField = ({ label, name, type, value, placeholder, onChange }) => (
//   <div className="space-y-1">
//     <label htmlFor={name} className="block text-sm font-medium text-gray-700">
//       {label}
//     </label>
//     <input
//       type={type}
//       name={name}
//       id={name}
//       value={value || ""}
//       onChange={onChange}
//       placeholder={placeholder}
//       className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
//     />
//   </div>
// );

// const SelectField = ({ label, name, value, onChange, options }) => (
//   <div className="space-y-1">
//     <label htmlFor={name} className="block text-sm font-medium text-gray-700">
//       {label}
//     </label>
//     <select
//       name={name}
//       id={name}
//       value={value || ""}
//       onChange={onChange}
//       className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
//     >
//       <option value="">Select {label}</option>
//       {options?.map((option) => (
//         <option key={option} value={option}>
//           {option}
//         </option>
//       ))}
//     </select>
//   </div>
// );

// export default ProfilePages;